import { render, staticRenderFns } from "./TokenDetail.m.vue?vue&type=template&id=71cb359d&scoped=true&"
import script from "./TokenDetail.m.vue?vue&type=script&lang=js&"
export * from "./TokenDetail.m.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetail.m.vue?vue&type=style&index=0&id=71cb359d&lang=scss&scoped=true&"
import style1 from "./TokenDetail.m.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb359d",
  null
  
)

export default component.exports